{
  "name": "production",
  "hostname": "serveport.com",
  "default": null,
  "development": false,
  "production": true,
  "applicationName": "ServePort",
  "sourceVersion": "94961ca1555d0485d35917c2e19a1b4b445311e9",
  "errors": {
    "numRetries": 3
  },
  "urls": {
    "apiRootCoManage": "https://@.serveport.com/_api/comanage/",
    "apiRootLpms": "https://@.serveport.com/_api/lpms/",
    "apiRootSquirrel": "https://@.serveport.com/_api/squirrel/",
    "apiRootRms": "https://@.serveport.com/_api/rms/"
  },
  "stripe": {
    "key": "pk_live_Js6GjAAEvwtOZ3ZNvGe149jU00TGO4Jqgw"
  },
  "auth0": {
    "authorityRoot": "auth.safarilaw.com",
    "clientId": "cPuIsG207eQuD6RWEFZmHQqbjPnPjIRk",
    "useLocalStorageCache": false
  },
  "auth": {
    "inactivityTimeout": 0,
    "inactivityWarning": 0
  },
  "statusApp": {
    "apiRootUrl": "https://@.serveport.com/_api/maintenance/",
    "code": "IldIjcjp1bhvMua1TOMwNdt1v7FZl3C04LmnVpQWj2pdAzFuobNqfA==",
    "cacheDurationInMinutes": 5
  },
  "featureFlags": {
    "demoPreviews": false,
    "devTools": false,
    "devExceptions": false,
    "inputRelativeValidation": true,
    "enableServiceOfProcessBusinessHours": true
  },
  "loggers": {
    "elmah": {
      "apiKey": "752d3d5a800541cd8dd1b5d747cc188a",
      "logId": "3866225d-479d-4694-ba82-471c763c47d1"
    },
    "appInsights": {
      "connectionString": "InstrumentationKey=6d15b261-ac17-4b93-b93a-afd6fded4add;IngestionEndpoint=https://eastus-3.in.applicationinsights.azure.com/;LiveEndpoint=https://eastus.livediagnostics.monitor.azure.com/;ApplicationId=08d48b1f-a73a-4bd7-a99e-61d96d37ec07"
    }
  },
  "uiSettings": {
    "hasNavbar": true,
    "list": {
      "maxCountInMemory": 10000,
      "pageSize": 20
    },
    "maxSubtypesToShowInDropdown": 0,
    "updatePollFrequency": 3600,
    "richTextEditor": {
      "initializationTimeoutInMs": 2000
    },
    "file": {
      "previewDialogTimeLimitInSeconds": 5,
      "downloadTarget": "_self",
      "tusUploadLimitInMb": 0,
      "maxCorrespondenceSizeAttachmentInMb": 20
    },
    "reports": {
      "key": "Z70R-XG6J5I-274219-0W0Y0F-734Y3H-5I460R-0H445W-4F6S27-2G5S1J-4P291I-2E5N"
    }
  },
  "signalR": {
    "hubs": [
      {
        "api": "rms",
        "name": "submissions",
        "url": "signalr/submissions"
      }
    ]
  }
}
